import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _sortBy from 'lodash/sortBy';
import { getUserInfo } from 'Utils';
import * as analytics from 'Utils/analytics';
import {
  deleteInterestsArray,
  saveInterestsArray,
  setOptout,
} from 'Services/interests';
import Checkbox from 'Components/Checkbox';
import LoadingDots from 'Components/LoadingDots';
const { EVENTS } = analytics;

const InterestsSelector = ({
  closeInterests,
  formatInterests,
  hasInterests,
  interests,
  interestsArray,
  strings,
  uim,
  userInterests,
}) => {
  const [selections, setSelections] = useState(userInterests);
  const [submitting, setSubmitting] = useState(false);
  const [valid, setValid] = useState(false);

  const onChange = (event) => {
    if (event.target.checked) {
      select(event.target.value);
    } else {
      remove(event.target.value);
    }
  };

  const select = (item) => {
    analytics.event({ action: EVENTS.selectInterestItem, label: item });
    const items = [...selections, item];
    setSelections(items);
  };

  const remove = (item) => {
    analytics.event({ action: EVENTS.deselectInterestItem, label: item });
    const items = selections.filter((selections) => selections !== item);
    setSelections(items);
  };

  const isValid = () => {
    // enable submission if there are changes
    const invalid = _isEqual(_sortBy(selections), _sortBy(userInterests));
    if (invalid) {
      setValid(false);
    } else {
      setValid(true);
    }
  };

  useEffect(isValid, [selections]);

  const updateInterests = async (selections) => {
    const { userToken, userId } = await getUserInfo(uim);
    const additions = selections.filter((x) => !userInterests.includes(x));
    const deletions = userInterests.filter((x) => !selections.includes(x));
    const optout = hasInterests && selections.length === 0;
    let saved = await saveInterestsArray(additions, userId, userToken);
    let deleted = await deleteInterestsArray(deletions, userId, userToken);
    let optoutUpdated = await setOptout(optout, userId, userToken);
    return { saved, deleted, optoutUpdated };
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    const updated = await updateInterests(selections);
    if (updated) {
      formatInterests();
      closeInterests();
    }
  };

  return (
    <form className="row__form" onSubmit={onSubmit}>
      <div className="checkbox__grid">
        {interestsArray.map((interest) => (
          <Checkbox
            defaultChecked={userInterests.includes(interest)}
            key={interest}
            onChange={onChange}
            text={interests[interest].name}
            value={interest}
          />
        ))}
      </div>
      <div className="row__buttons">
        <button
          className={`btn--short ${submitting ? 'btn--submitting' : ''}`}
          type="submit"
          disabled={!valid || submitting}
        >
          {submitting ? <LoadingDots /> : strings.confirm}
        </button>
        <button
          className="btn--short btn--secondary"
          onClick={closeInterests}
          disabled={submitting}
        >
          {strings.cancel}
        </button>
      </div>
    </form>
  );
};

InterestsSelector.propTypes = {
  closeInterests: PropTypes.func,
  formatInterests: PropTypes.func.isRequired,
  hasInterests: PropTypes.bool.isRequired,
  interests: PropTypes.object.isRequired,
  interestsArray: PropTypes.array.isRequired,
  strings: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
  userInterests: PropTypes.array.isRequired,
};

InterestsSelector.defaultProps = {
  closeInterests: () => {},
};

export default InterestsSelector;
